import { Box } from '@mui/material';
import React from 'react';
import { publicAsset } from '@utils/publicAsset';

const Logo = ({ size, className }: { size?: number; className?: string }) => {
  const style = { width: size || '100%', height: 'auto' };
  return (
    <Box sx={style}>
      <img src={publicAsset('/logo-outline-128.png')} alt="Logo" className={className} />
    </Box>
  );
};

export const JotPsychWordmarkLogo = ({
  size,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  const style = { width: size || '100%', height: 'auto' };
  return <img src={publicAsset('/jotpsych-logo.png')} alt="JotPsych" style={style} className={className} />;
};

export default Logo;
